import React, {Component} from "react";
import PropTypes from "prop-types";
import axios from "axios";
import {authorizationHeaders} from "./api";
import {printReadModel} from "./print";
import {Button, Col, Row, Table} from "antd";

export class Report extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    readModelName: PropTypes.string.isRequired,
    columns: PropTypes.array.isRequired,
    filterProvider: PropTypes.func.isRequired,
    rowKey: PropTypes.string.isRequired,
    transformData: PropTypes.func,
    printHeader: PropTypes.string,
  };
  state = {
    loading: true,
    data: []
  };

  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.transformData !== prevProps.transformData) this._load();
  }

  async _load() {
    const filter = this.props.filterProvider(this.props);
    try {
      const res = await axios.get(
        `${process.env.PUBLIC_URL}/api/v1/r/${this.props.readModelName}?filter=${encodeURIComponent(JSON.stringify(filter))}&_=${Date.now()}`,
        {headers: authorizationHeaders()}
      );
      const transformData = this.props.transformData ? this.props.transformData : x => x;
      this.setState({data: transformData(res.data), loading: false});
    } catch (err) {
      //TODO notification
      console.error(err);
    }
  }

  _handlePrint = () => printReadModel(this.props.title, this.props.readModelName, this.props.columns, this.props.filterProvider(this.props), {
    style: `th, td { border-bottom: 1px dashed black; }`,
    header: `<h2>${this.props.title}</h2>${this.props.printHeader || ''}`,
    dataTransform: this.props.transformData
  });

  render() {
    return <div>
      <Row>
        <Col span={12}><h2>{this.props.title}</h2></Col>
        <Col span={12} style={{textAlign: 'right'}}><Button key="print-button" icon="printer" onClick={this._handlePrint}>Print</Button></Col>
      </Row>
      <Table columns={this.props.columns} dataSource={this.state.data} rowKey={this.props.rowKey} pagination={false} loading={this.state.loading}>
      </Table>
    </div>;
  }
}

export default function report(title, readModelName, columns, rowKey, filterProvider, options = {}) {
  return props => <Report title={title} readModelName={readModelName} columns={columns} rowKey={rowKey}
                          filterProvider={filterProvider} options={options} {...props} />;
}



// WEBPACK FOOTER //
// ./src/utils/report.js